<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Official — Instagram Full Access</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link to="/instagram/accounts/list_official">List Accounts</router-link>
                  </li>
                  <li class="breadcrumb-item active">Add Account</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- /Search Filter -->
          <div class="row">
            <div class="col-md-12 col-lg-6 col-xl-6 d-flex">
              <div class="card flex-fill">
                <div class="card-body">
                  <h4 class="card-title">Full Access</h4>
                  <div class="statistics">
                    <p
                      class="text-muted"
                    >Allows Instagram Professionals — Businesses and Creators — to manage its presence on Instagram, find hashtagged media, and get basic metadata and metrics about other Instagram Businesses and Creators.</p>
                    <h4 class="card-title">Before You Start</h4>
                    <span class="text-muted">You will need access to the following:</span>
                    <ul>
                      <li>
                        An
                        <a
                          href="https://help.instagram.com/502981923235522?fbclid=IwAR0QyyjxqL0PT8WxFogNeNakz1xuvKYmGh53QeqT3IhNhAx3enUUPPL47TE"
                          target="_blank"
                          rel="noopener nofollow"
                          data-lynx-mode="asynclazy"
                          data-lynx-uri="https://l.facebook.com/l.php?u=https%3A%2F%2Fhelp.instagram.com%2F502981923235522%3Ffbclid%3DIwAR0QyyjxqL0PT8WxFogNeNakz1xuvKYmGh53QeqT3IhNhAx3enUUPPL47TE&amp;h=AT3wxMg8_QOoZLOWSDy5Y5ytcMUQDoH_bRCycjha8Pd7dcKMgDHqwvmi1rMquN0a6bgYH1C3wStngFfzQwCcQqS13wv5iFZlvTO-uWVPmUcyXXj4_1VdHdGYmBZtSSHVEqPMuMNdJEY"
                        >Instagram Business Account</a> or
                        <a
                          href="https://help.instagram.com/1158274571010880?fbclid=IwAR0iKSP5MVPR5-3oxn3N3iNuLf4I3TVEEf8MnumHa4uUsedlxMzCB-MHIZs"
                          target="_blank"
                          rel="noopener nofollow"
                          data-lynx-mode="asynclazy"
                          data-lynx-uri="https://l.facebook.com/l.php?u=https%3A%2F%2Fhelp.instagram.com%2F1158274571010880%3Ffbclid%3DIwAR0iKSP5MVPR5-3oxn3N3iNuLf4I3TVEEf8MnumHa4uUsedlxMzCB-MHIZs&amp;h=AT0T1h-Cl5r2zGniRgPnUvf61PcucFdUDWxcCx63nhpI38PJZy0rXKiDx1TcSd4s28ZbVOJ94cjLzskJ6JGABKf8xC1BZiWsxno_yj9DnW8kgFap59iCBmSK8mIGverB4BnK0LQLWx0"
                        >Instagram Creator Account</a>
                      </li>
                      <li>
                        A
                        <a
                          target="_blank"
                          href="https://developers.facebook.com/docs/instagram-api/overview#pages"
                        >Facebook Page connected to that account</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-lg-6 col-xl-6 d-flex">
              <div class="card container">
                <div class="row align-items-center h-100">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>
                        Brand:
                        <span class="text-danger">*</span>
                      </label>
                      <div class="form-group">
                        <multiselect
                          v-model="selectedContact"
                          id="ajax"
                          label="brand_name"
                          track-by="id"
                          :placeholder="'Type to search Brand...'"
                          :multiple="true"
                          open-direction="bottom"
                          :custom-label="customLabel"
                          :options="contactOptions"
                          :searchable="true"
                          :loading="isLoading"
                          :internal-search="false"
                          :close-on-select="false"
                          :options-limit="300"
                          :limit="3"
                          :limit-text="limitText"
                          :max-height="600"
                          :show-no-results="true"
                          :hide-selected="true"
                          @search-change="asyncFind"
                          :show-labels="false"
                        >
                          <template slot="tag" slot-scope="{ option, remove }">
                            <span class="custom__tag">
                              <span>{{option.name}}</span>
                              <span class="custom__remove" @click="remove(option)">❌</span>
                            </span>
                          </template>
                          <template slot="clear" slot-scope="props">
                            <div
                              class="multiselect__clear"
                              v-if="selectedContact.length"
                              @mousedown.prevent.stop="clearAll(props.search)"
                            ></div>
                          </template>
                          <span slot="noResult">Oops! No elements found.</span>
                        </multiselect>
                      </div>
                    </div>
                    <div class="text-center" v-if="selectedContact.length">
                      <div v-if="loadingFB" style="margin-top:20px;">Sedang mengalihkan...</div>
                      <div v-else>
                        <v-facebook-login
                          v-if="FBComponent.scope.logout && FBComponent.model.connected"
                          v-model="FBComponent.model"
                          type="button"
                          :style="'width:100%;margin-top:10px;'"
                          :app-id="FBComponent.appId"
                          :use-alt-logo="true"
                          class="btn-default-costume btn-facebook"
                          tabindex="6"
                          @sdk-init="handleSdkInit"
                          @login="handleSdkLogin"
                          :version="'v16.0'"
                          :login-options="FBComponent.scopeInstagramPermissionsInsight"
                        />
                        <v-facebook-login
                          v-else
                          v-model="FBComponent.model"
                          v-slot:login
                          type="button"
                          tabindex="6"
                          :style="'width:100%;margin-top:10px;'"
                          :app-id="FBComponent.appId"
                          :use-alt-logo="true"
                          class="btn-default-costume btn-facebook"
                          @sdk-init="handleSdkInit"
                          @login="handleSdkLogin"
                          :version="'v16.0'"
                          :login-options="FBComponent.scopeInstagramPermissionsInsight"
                        >Masuk Dengan Facebook</v-facebook-login>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">&nbsp;</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>

    <a
      v-show="false"
      ref="formSelectAccounts"
      class="btn add-btn"
      href="#"
      data-toggle="modal"
      data-target="#formSelectAccounts"
    >
      <i class="la la-user"></i> Select Accounts
    </a>
    <div id="formSelectAccounts" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Select Accounts</h5>
            <!-- {{formParam}} -->
            <button
              ref="dismisModal"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-md-12 col-lg-12 col-xl-12">
              <div class="text-right">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" v-model="selectAllTable" />
                  </label>
                </div>
              </div>
              <!-- {{selectedTable}} -->
            </div>
            <div class="col-md-12 col-lg-12 col-xl-12 d-flex">
              <div class="flex-fill" v-if="instagramAccounts.length">
                <template v-for="(row,idx) in instagramAccounts">
                  <div
                    v-if="row.instagram_business_account.id!=''"
                    :key="idx"
                    class="leave-info-box"
                  >
                    <div class="media align-items-center">
                      <a
                        :href="'https://www.instagram.com/'+row.instagram_business_account.username"
                        target="_blank"
                        class="avatar"
                      >
                        <img
                          style="width:100%"
                          alt
                          :src="row.instagram_business_account.profile_picture_url"
                        />
                      </a>
                      <div class="media-body">
                        <div class="text-sm my-0">
                          <a
                            :href="'https://www.instagram.com/'+row.instagram_business_account.username"
                            target="_blank"
                          >{{row.instagram_business_account.username}}</a>
                        </div>
                      </div>
                    </div>
                    <div class="row align-items-center mt-3">
                      <div class="col-6">
                        <span class="text-sm text-muted">{{row.instagram_business_account.name}}</span>
                      </div>
                      <div class="col-6 text-right">
                        <div class="checkbox">
                          <label>
                            <input
                              type="checkbox"
                              v-model="selectedTable"
                              :value="row.instagram_business_account.id"
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <div class="text-right">
                  <button
                    class="btn btn-light text-dark"
                    href="javascript:void(0);"
                    data-dismiss="modal"
                  >Cancel</button>
                  <button
                    @click.prevent="connectAccountsFullAccess"
                    class="btn btn-primary"
                    :disabled="loadingConnect"
                  >Connect</button>
                </div>
              </div>
              <div class="flex-fill" v-else>
                <div class="text-center alert alert-danger">Instagram business account not found.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import VFacebookLogin from "vue-facebook-login-component";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    Multiselect,
    VFacebookLogin
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      loadingConnect: false,
      formConnectFb: {
        brand_id: [],
        access_token: "",
        instagram_business_account_id: [],
        instagram_profile: []
      },
      selectedTable: [],
      instagramAccounts: [],
      loadingFB: false,
      FBComponent: {
        version: process.env.VUE_APP_FACEBOOK_API_VERSION,
        appId: process.env.VUE_APP_FACEBOOK_APP_ID,
        FB: {},
        model: {},
        scope: {
          scope:
            "instagram_graph_user_media,pages_show_list,instagram_basic,instagram_manage_comments,instagram_manage_insights,instagram_content_publish,instagram_manage_messages,public_profile"
        }
      },
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        id: "",
        name: "",
        page: 0,
        perPage: 20
      },
      isLoading: false,
      formParam: {
        copy: false,
        brand_id: [],
        ig: {
          id: "",
          username: "",
          password: ""
        }
      }
    };
    //  isactive : true
  },
  computed: {
    selectAllTable: {
      get: function() {
        return this.rows
          ? this.selectedTable.length == this.instagramAccounts.length
          : false;
      },
      set: function(value) {
        var selectedTable = [];

        if (value) {
          this.instagramAccounts.forEach(function(row) {
            selectedTable.push(row.instagram_business_account.id);
          });
        }

        this.selectedTable = selectedTable;
      }
    }
  },
  watch: {
    selectedContact: {
      handler: function(val, oldVal) {
        // console.log("selectedLicense", val, oldVal);
        // if (val != oldVal) {
        if (val.length > 0) {
          this.formParam.brand_id = [];
          this.selectedContact.forEach((row, idx) => {
            this.formParam.brand_id.push(row.id);
          });
          return;
        }
        if (val != oldVal && oldVal.length == 1 && val.length < 1) {
          this.selectedContact = [];
          this.formParam.brand_id = [];
          return;
        }
      },
      deep: true
    }
  },
  created() {},
  methods: {
    connectAccountsFullAccess() {
      if (this.selectedTable.length < 1) {
        this.$fire({
          title: "Error",
          text: "Instagram Business Account is required",
          type: "error",
          timer: 2000
        }).then(r => {});
        return;
      }
      this.loadingConnect = true;
      this.formConnectFb.brand_id = this.formParam.brand_id;
      this.formConnectFb.brand_id = this.formParam.brand_id;
      this.formConnectFb.instagram_business_account_id = this.selectedTable;
      this.formConnectFb.instagram_profile = this.instagramAccounts;
      this.$store
        .dispatch(
          "instagramAccountOfficial/connectAccountsFullAccess",
          this.formConnectFb
        )
        .then(async response => {
          await this.instagramAccounts.forEach((row, idx) => {
            if (row.instagram_business_account.id != "") {
              this.$store.dispatch(
                "instagramAccountOfficial/updateUserStats",
                row.instagram_business_account.id
              );
            }
          });

          this.loadingConnect = await false;

          await this.$fire({
            title: "Connected",
            text: response.msg,
            type: "success",
            timer: 5000
          }).then(r => {
            var elem = this.$refs.dismisModal;
            elem.click();
            window.location.href =
              this.baseUrl + "/instagram/accounts/list_official";
          });
        })
        .catch(err => {
          this.loadingConnect = false;
        });
    },
    async handleSdkLogin(res) {
      if (res.status === "connected") {
        var accessToken = res.authResponse.accessToken;
        console.log("accessToken:", accessToken);
        this.loadingFB = await true;
        var that = await this;
        await this.FBComponent.FB.api(
          "/me?fields=id,email,name,picture,first_name,last_name",
          async function(data) {
            that.instagramAccounts = await [];
            that.formConnectFb.access_token = await accessToken;
            await that.$store
              .dispatch(
                "instagramAccountOfficial/getInstagramBusinessAccount",
                that.formConnectFb
              )
              .then(response => {
                that.instagramAccounts = response.data;
                // console.log("instagramAccounts:", response.data);
                var elem = that.$refs.formSelectAccounts;
                elem.click();
              });

            // console.log("data:", data);
            that.loadingFB = await false;
          }
        );
      } else {
        // alert(res.status);
        this.$fire({
          title: "Error",
          text: res.status,
          type: "error",
          timer: 2000
        }).then(r => {});
        this.loadingFB = await false;
      }
    },
    async handleSdkInit({ FB, scope }) {
      // console.log("scope::", scope)
      this.FBComponent.FB = FB;
      this.FBComponent.scope = scope;
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ name }) {
      return `${name}`;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.name = query;
      this.contactListParam.id = "";
      this.$store
        .dispatch("brand/list", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;

          // console.log("contactOptions", this.contactOptions);
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    asyncFindSelect(query, id) {
      this.isLoading = true;
      this.contactListParam.name = query;
      this.contactListParam.id = id;

      this.$store
        .dispatch("brand/list", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
          if (id != "") {
            if (this.contactOptions.length > 0) {
              this.selectedContact = this.contactOptions[0];
            }
          }
          // console.log("contactOptions", this.contactOptions);
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    clearAll() {
      this.selectedContact = [];
    }
  },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "officialContentPublishing"
};
</script>


// WEBPACK FOOTER //
// src/views/instagram/instagramAccount/officialFullAccess.vue